import Image from 'next/image'
import { Box } from '@bridge/ui'
import colors from 'app/colors'

export const CloseButton = ({
	onClick,
	color,
}: {
	onClick: () => void
	color?: string
}) => {
	return (
		<Box
			borderRadius={1}
			sx={{ cursor: 'pointer' }}
			onClick={onClick}
		>
			<Image
				src="/close-icon.svg"
				alt="close"
				width={24}
				height={24}
				style={{ color: color ?? colors.grey900 }}
			/>
		</Box>
	)
}
